$(document).ready( function() {
    $(function() {
      var noweekends = datepicker_noweekends, noweekends_val;
      var maxdate = "+"+datepicker_maxdate+"W";
      var mindate = datepicker_mindate;
      if (noweekends==true){
        noweekends_val = jQuery.datepicker.noWeekends;
      } else {
        noweekends_val = false;
      }
      $("#date").datepicker( {
        dateFormat: 'dd/mm/yy',
        minDate: mindate,
        maxDate: maxdate,
        beforeShowDay: noweekends_val
      });
    });
  }); 




// .format();

//         beforeShowDay: noweekends_val
        
// 		beforeShowDay: function (d) {
//                         var day = d.getDay();
//                         return [day != 0 && day != 3 && day != 4 && day != 5 && day != 6 && day != 7];
//                     },   